import * as actionTypes from "./actionTypes";

const initialState = {
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    ruleData: {},
    ruleList: [],

    loading: false,
    loadingGetRequest: false,
    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    ruleWasCreated: false,
    ruleWasEdited: false,
    ruleWasDeleted: false,

    error: undefined
};

const rulesReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.GET_RULE_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.GET_RULE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                ruleList: payload
            };
        case actionTypes.GET_RULE_LIST_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.RULE_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.RULE_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_RULE_REQUEST:
            return {
                ...state,
                loadingGetRequest: true,
            };
        case actionTypes.GET_RULE_SUCCESS:
            return {
                ...state,
                loadingGetRequest: false,
                ruleData: payload,
            };
        case actionTypes.GET_RULE_FAILED:
            return {
                ...state,
                loadingGetRequest: false,
            };

        case actionTypes.DELETE_RULE_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_RULE_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                ruleWasDeleted: true
            };
        case actionTypes.DELETE_RULE_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                ruleWasDeleted: false
            };
        case actionTypes.EDIT_RULE_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_RULE_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                ruleWasEdited: true
            };
        case actionTypes.EDIT_RULE_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                ruleWasEdited: false
            };
        case actionTypes.CREATE_RULE_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_RULE_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                roleWasCreated: true
            };
        case actionTypes.CREATE_RULE_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                roleWasCreated: false
            };
        default:
            return state;
    }
};

export default rulesReducer;